import { browser } from '$app/environment';
import { cookies } from './Cookies.svelte';
import {
	PersonalizationDataValidator,
	PersonalizationTypes,
	type PersonalizationData
} from '../types/Personalization';
import { CookieNames } from '$lib/types/CookieNames';
import { fromZodError, type ZodError } from 'zod-validation-error';
import { Bugs } from '$lib/BugsService';

class TrackingInstance {
	private _data: PersonalizationData = {
		events: []
	};
	public get data() {
		return this._data;
	}

	public init = () => {
		if (!browser || !cookies.consents.get('functional')) return;
		const cookie = cookies.get(CookieNames.PERSONALIZATION);
		if (!cookie) return;

		try {
			const data = JSON.parse(cookie);
			const parsed = PersonalizationDataValidator.safeParse(data);
			if (parsed.success) {
				this._data = parsed.data;
				return parsed.data;
			} else {
				throw new Error(fromZodError(parsed.error as ZodError).toString());
			}
		} catch (e) {
			console.error('Failed to parse personalization data when initializing', e);
		}
	};

	public track = (type: PersonalizationTypes, data: any) => {
		if (!browser) return;
		this._data.events.push({ type, data });
		this.save();
	};

	private save = () => {
		if (!browser) return;
		if (cookies.consents.get('functional')) {
			const parsed = PersonalizationDataValidator.safeParse(this._data);
			if (parsed.success) {
				cookies.set(CookieNames.PERSONALIZATION, JSON.stringify(this._data), 'functional');
			} else {
				Bugs.reportError(new Error('Failed to parse personalization data when saving'), {
					error: parsed.error
				});
			}
		}
	};
}

export const personalizationTracking = new TrackingInstance();
